import { Injector } from '@angular/core';
import { ENV_NAME } from '@y42/environment';
import { FeatureFlags } from '@y42/feature-flag';

export enum Y42FeatureFlag {
  EnableWatchers = 'watchers',
  EnableLowCodeToCodeToggleButton = 'low_code_to_code_toggle_button',
  EnableAlertsAndNotificationsAdmin = 'alerts_notifications_admin',
  EnableDraftIntegrationConfigs = 'draft_integration_configs',
  EnableNewTriggerApi = 'new_trigger_api',
  EnableFullPreviewInPreviewTab = 'full_preview_in_preview_tab',
  EnableDbtPackages = 'dbt_packages',
}

// const enableInLocal = (injector: Injector) => injector.get(ENV_NAME) === 'local';
const enableInLocalAndDev = (injector: Injector) => ['local', 'dev'].includes(injector.get(ENV_NAME));

export const Y42_FEATURE_FLAGS: FeatureFlags<Y42FeatureFlag> = {
  [Y42FeatureFlag.EnableWatchers]: false,
  [Y42FeatureFlag.EnableLowCodeToCodeToggleButton]: true,
  [Y42FeatureFlag.EnableAlertsAndNotificationsAdmin]: enableInLocalAndDev,
  [Y42FeatureFlag.EnableDraftIntegrationConfigs]: false,
  [Y42FeatureFlag.EnableNewTriggerApi]: true,
  [Y42FeatureFlag.EnableFullPreviewInPreviewTab]: false,
  [Y42FeatureFlag.EnableDbtPackages]: false,
};
